import PropTypes from 'prop-types';
import React from 'react';
import StyledP from './BodyCopy.styled';

const BodyCopy = ({
  children,
  paragraphType,
  paragraphText,
  paragraphColor,
}) => {
  return (
    <StyledP
      className="body-copy-component"
      paragraphType={paragraphType}
      paragraphColor={paragraphColor}
    >
      {paragraphText}
      {children}
    </StyledP>
  );
};

BodyCopy.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  paragraphColor: PropTypes.any,
  paragraphText: PropTypes.any,
  paragraphType: PropTypes.string,
};

export default BodyCopy;
